/**
 * BentoDashboard — Anti-Scroll 4-Quadrant Layout
 *
 * Replaces the infinite-scroll feed with a static, curated dashboard.
 * Users log in, consume high-signal information, and leave.
 *
 * ┌───────────────────────┬───────────────────────┐
 * │  NumaPick (Anchor)    │  MostEngaged (Pulse)  │
 * │  Featured post of day │  Highest engagement   │
 * ├───────────────────────┼───────────────────────┤
 * │  TheLatest (Chrono)   │  YourCircle (Network) │
 * │  3 most recent posts  │  Linked users' posts  │
 * └───────────────────────┴───────────────────────┘
 */

import type { ClubTheme } from './themes';
import type { SocialPost } from './types';
import NumaPick from './NumaPick';
import MostEngaged from './MostEngaged';
import TheLatest from './TheLatest';
import YourCircle from './YourCircle';

interface BentoDashboardProps {
  clubId: string;
  theme: ClubTheme;
  onViewArchive?: () => void;
  onPostClick?: (post: SocialPost) => void;
  onRefresh?: () => void;
  onQuote?: (post: SocialPost) => void;
  onNavigateToPost?: (postId: string) => void;
}

export default function BentoDashboard({
  clubId,
  theme,
  onViewArchive,
  onPostClick,
  onRefresh,
  onQuote,
  onNavigateToPost,
}: BentoDashboardProps) {
  return (
    <div className="grid grid-cols-1 gap-3 md:gap-4 md:grid-cols-2 md:grid-rows-2 md:min-h-[520px]">
      {/* Top-left: Numa's Pick — The Anchor */}
      <div className="min-h-[140px] md:min-h-0">
        <NumaPick
          clubId={clubId}
          theme={theme}
          onPostClick={onPostClick}
        />
      </div>

      {/* Top-right: Most Engaged — Community Pulse */}
      <div className="min-h-[140px] md:min-h-0">
        <MostEngaged
          clubId={clubId}
          theme={theme}
          onPostClick={onPostClick}
        />
      </div>

      {/* Bottom-left: The Latest — Chronological */}
      <div className="min-h-[160px] md:min-h-0">
        <TheLatest
          clubId={clubId}
          theme={theme}
          onViewArchive={onViewArchive}
          onRefresh={onRefresh}
          onQuote={onQuote}
          onNavigateToPost={onNavigateToPost}
        />
      </div>

      {/* Bottom-right: Your Circle — Personal Network */}
      <div className="min-h-[140px] md:min-h-0">
        <YourCircle
          clubId={clubId}
          theme={theme}
          onPostClick={onPostClick}
        />
      </div>
    </div>
  );
}
